module.exports = __webpack_public_path__ + "img/title.a2622446.png";